import { Framework } from "../models/projectModel";

export const flutter: Framework = {
  name: "Flutter",
  icon: "flutter.png",
  key: "flutter",
  svg: "flutter-logo.svg"
};
export const react: Framework = {
  name: "React",
  icon: "react.png",
  key: "react",
  svg: "react-logo.svg"
};
export const vue: Framework = {
  name: "Vue",
  icon: "vue.png",
  key: "vue",
};
export const flask: Framework = {
  name: "Flask",
  icon: "flask.png",
  key: "flask",
};
export const python: Framework = {
  name: "Python",
  icon: "python.png",
  key: "python",
};
export const cad: Framework = {
  name: "CAD",
  icon: "cad.png",
  key: "cad",
};

export const googlePlay: Framework = {
  name: "Google Play Store",
  icon: "google-play-badge.png",
  key: "google-play-badge",
};

export const github: Framework = {
  name: "Github",
  icon: "github.png",
  key: "github",
};

export const gitlab: Framework = {
  name: "Gitlab",
  icon: "gitlab.png",
  key: "gitlab",
};
export const nextjs: Framework = {
  name: "Next.js",
  icon: "nextjs.png",
  key: "nextjs",
};

export const allFrameworks: Framework[] = [
  flutter,
  react,
  nextjs,
  vue,
  flask,
  python,
  cad,
  github,
  
];


export function FrameworkFromKey(key:string) {
  const framework =  allFrameworks.find((e)=> e.key === key);
  return framework;
}